import { arrayOf } from 'prop-types'
import { PersonType } from './personDataProps'

export default arrayOf(PersonType)
